/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EnergyConsumptionCip { 
    total?: number;
    kwhPerH?: number;
    kwhPerCip?: number;
    kWh_per_cip?: number;
    kWh_per_h?: number;
}

